//🇫🇷
export const fr = {
    ApplicationName: 'Detam',

    //* COMMONS
    COMMON_YES: 'Oui',
    COMMON_NO: 'Non',
    COMMON_REQUIRED_FIELD: 'Champ obligatoire*',
    COMMON_EMPTY_MESSAGE: 'Aucun résultat',
    COMMON_ADD: 'Ajouter',
    COMMON_CHANGE: 'Modifier',
    COMMON_BAD_VALUE_FIELD: 'Champ erroné',
    COMMON_EXPORT: 'Exporter',
    COMMON_IMPORT: 'Parcourir',
    COMMON_SAVE: 'Enregistrer',
    COMMON_VALIDATE: 'Valider',
    COMMON_CANCEL: 'Annuler',
    COMMON_DELETE: 'Supprimer',
    COMMON_SEARCH: 'Recherche',
    COMMON_SEARCH_TITLE: 'Rechercher',
    COMMON_PLACEHOLDER: '_',
    COMMON_EMPTY: '-',
    COMMON_ENABLED: 'Actif',
    COMMON_DISABLED: 'Inactif',
    COMMON_SAVE_SUCCESS: 'Enregistrement réussi !',
    COMMON_LOADING: 'Chargement...',

    //* ERRORS
    Error_GenericError: "Quelque chose ne s'est pas passé comme prévu, merci de réessayer",
    Error_EmptySharepointLink: 'Adresse du lien vide, veuillez saisir un lien valable',
    Error_RequiredFieldsCannotBeEmpty:
        'Erreur. Pour enregistrer votre saisie, tous les champs obligatoires doivent être saisis.',
    Error_AFFAIRE_NUMBER_DUPLICATION:
        'Enregistrement impossible, ce code chantier est déjà utilisé',
    Error_INVALID_SP_LIBRARY_REFERENCE:
        'Le lien de la bibliothèque SharePoint n’est pas correct, pour enregistrer votre saisie vous devez le corriger',
    Error_COMPAGNON_INVALID_EMAIL_FORMAT: "Le format le l'email n'est pas correct",
    Error_CAUSERIE_ALREADY_PUBLISHED: 'Cette causerie a déjà été publiée',
    Error_AFFAIRE_ACTIVE_FIELDS_MISSING:
        'Le chantier ne peut pas être activé car il manque des champs obligatoire',
    Error_INCOMPLETE_CAUSERIE_PUBLICATION:
        'Pour publier la causerie, vous devez saisir au moins 1 titre, 1 description et joindre 1 pdf',
    Error_TEMPLATE_USED_BY_AFFAIRES: 'Le controle est utilisé dans un chantier',
    Error_TRIGRAM_INVALID_FORMAT: 'Un trigramme doit comporter 3 lettres',
    Error_FORBIDDEN: "Vous n'êtes pas authorisé à accéder au backoffice",
    Error_INVALID_CREDENTIALS_MESSAGE: 'Les identifiants renseignés semblent être erronés.',
    Error_INVALID_COMPAGNON_REFERENCE: 'Le compagnon sélectionné ne peut pas être inactif.',
    Error_INVALID_CLIENT_REFERENCE: 'Le client sélectionné ne peut pas être inactif.',
    Error_USER_DOES_NOT_HAVE_BACK_ACCESS: "L'utilisateur n'a pas accès à l'application",
    Error_INCOMPLETE_CHECK_TEMPLATE:
        "Le modèle de contrôle nécessite plus d'informations pour être activé. Erreur : Doit avoir au moins 1 section",
    Error_INVALID_IMAGE_FORMAT: 'Le fichier sélectionné n’est pas une image valide',
    Error_IMAGE_COUNT_LIMIT_EXCEEDED: "Impossible d'ajouter plus de 20 images.",

    Error_WEAK_PASSWORD: 'Votre mot de passe est trop faible.',

    User_FullName: '{firstName} {lastName}',

    Login_Title: 'Bienvenue',
    Login_SubTitle:
        'Merci de vous connecter avec votre adresse Email pour accéder à votre espace personnel.',
    Login_Email: 'Email',
    Login_Password: 'Mot de passe',
    Login_ForgotPassword_ButtonTitle: 'Mot de passe oublié ?',
    Login_ButtonTitle: 'Se connecter',
    Login_InvalidEmail: 'Email non reconnu',
    Login_InvalidPassword: 'Mot de passe non reconnu',
    Login_InvalidCredentialsMessage:
        'Les identifiants renseignés semblent être erronés. Veuillez réessayer ou réinitialisez votre mot de passe via le lien « Mot de passe oublié ? »',

    ForgotPassword_Title: 'Bienvenue',
    ForgotPassword_SubTitle:
        'Merci de renseigner votre adresse mail afin de réinitialiser votre mot de passe.',
    ForgotPassword_Email: 'Email',
    ForgotPassword_Login_ButtonTitle: 'Retour à la connexion',
    ForgotPassword_ButtonTitle: 'Envoyer',
    ForgotPassword_Success:
        'Votre demande a bien été prise en compte. Si vous faites partie de la base de données, un email de réinitialisation vous sera envoyé dans les plus brefs délais.',

    ResetPassword_Title: 'Bienvenue',
    ResetPassword_SubTitle: 'Merci de saisir votre nouveau mot de passe.',
    ResetPassword_Password: 'Mot de passe',
    ResetPassword_PasswordConfirmation: 'Confimation de mot de passe',
    ResetPassword_PasswordConfirmationError:
        'Le mot de passe doit être identique dans les deux champs',
    ResetPassword_ButtonTitle: 'Valider',
    ResetPassword_Success: 'Votre nouveau mot de passe a bien été pris en compte',
    ResetPassword_Rules_1:
        'Votre mot de passe doit contenir, au moins 8 caractères et 3 des 4 règles suivantes :',
    ResetPassword_Rules_2: 'une minuscule',
    ResetPassword_Rules_3: 'une majuscule',
    ResetPassword_Rules_4: 'un chiffre',
    ResetPassword_Rules_5: 'un caractère spécial',

    Header_Logout: 'Se déconnecter',

    Navbar_DayControles: 'Contrôles du jour',
    Navbar_Controles: 'Contrôles',
    Navbar_Pointages: 'Pointages',
    Navbar_Affaires: 'Chantiers',
    Navbar_Causeries: 'Causeries',
    Navbar_RH: 'RH',
    Navbar_Engins: 'Engins',
    Navbar_Materiels: 'Materiels',
    Navbar_Clients: 'Clients',
    Navbar_Vehicules: 'Vehicules',
    Navbar_Message: 'Message',
    Navbar_Planning: 'Planning',

    //* CONTROLE DU JOUR
    ControleListToday_Title: 'Contrôles du jour',
    ControleListToday_DateFormat: 'EEEE dd MMMM yyyy',

    //* CONTROLE TEMPLATES
    ControleList_Title: 'Contrôles',
    ControleList_ShowControlByEnabled: 'Afficher uniquement les contrôles actifs',
    ControleList_CreateControle: 'Nouveau',

    ControleList_Header_Controle: 'Contrôle',
    ControleList_Header_CreatedBy: 'Créé par',
    ControleList_Header_QuestionCount: 'Nb de questions',
    ControleList_Header_Type: 'Type',
    ControleList_Header_Status: 'Statut',

    //* CONTROLES
    ControleCreate_Title: 'Ajouter un contrôle',
    ControleCreate_PreviousTitle: 'Modèles de contrôles',
    ControleCreate_SuccessTitle: 'Bravo! le modèle de contrôle à été créee avec succès',

    ControleDetails_PreviousTitle: 'Modèles de contrôles',
    ControleDetails_DeleteTemplateTitle: 'Supprimer ce modèle de contrôle',
    ControleDetails_DeleteTemplateContent:
        'Êtes-vous sûr de vouloir supprimer ce modèle de contrôle ?',

    Controle_TabInfoTitle: 'Informations générales',
    Controle_TabQuestionsTitle: 'Questions',
    Controle_TabResultsTitle: 'Resultats',

    ControleInfo_Title: 'Nom de contrôle*',
    ControleInfo_IsActivated: 'Contrôle actif',
    ControleInfo_StateActive: 'Contrôle actif',
    ControleInfo_StateInactive: 'Contrôle inactif',
    ControleInfo_Description: 'Description',
    ControleInfo_Code: 'Code de contrôle*',
    ControleInfo_LinkedWithChantier: 'Lié à un chantier?*',
    ControleInfo_OptionTitle: 'Option {number}*',
    ControleInfo_OptionTitle_Optional: 'Option {number}',
    ControleInfo_OptionCount: '{count} / 3',
    ControleInfo_DeleteTemplate: 'Supprimer le contrôle',

    ControleQuestions_SectionTitle: 'Nom de section*',
    ControleQuestions_QuestionNumberTitle: 'Question {number}',
    ControleQuestions_AddQuestion: 'Ajouter une question',
    ControleQuestions_AddSection: 'Ajouter une section',
    ControleQuestions_DeleteSection: 'Supprimer la section',
    ControleQuestion_Mandatory: 'Réponse obligatoire',
    ControleQuestion_Label_SingleChoice: 'Choix',
    ControleQuestion_Label_Text: 'Texte',
    ControleQuestion_Label_Date: 'Date',
    ControleQuestion_Label_Signature: 'Signature',

    ControleQuestions_DeleteSectionTitle: ' Supprimer cette section',
    ControleQuestions_DeleteSectionTitleContent:
        'Êtes-vous sûr de vouloir supprimer cette section ?',
    ControleQuestions_DeleteQuestionTitle: 'Supprimer cette question',
    ControleQuestions_DeleteQuestionTitleContent:
        'Êtes-vous sûr de vouloir supprimer cette question ?',

    ControleResults_FilterCompagnons: ' Compagnons',
    ControleResults_FilterChantiers: ' Chantiers',
    ControleResults_FilterControles: 'Tous',
    ControleResults_FilterControles_DialogTitle: `Chargé d'affaires`,

    ControleInfo_NotInvalid: "Il y a des erreurs dans l'onglet 'Informations générales'",
    ControleQuestions_NotInvalid: "Il y a des erreurs dans l'onglet 'Questions'",

    Controle_GoToInformationTab: 'Voir les erreurs',
    Controle_GoToQuestionTab: 'Voir les erreurs',

    Controle_NoPDF: 'Aucun PDF disponible pour ce controle',
    Controle_NotDone: 'Non réalisé',
    Controle_NotDone_DateFormat: ' - {day} / {month} / {year} - {hour}h{minute}',

    Controle_Share: 'Activer le partage',
    Controle_Email: 'Email de destination*',
    Controle_Sharepoint: 'Enregistrer les résultats dans SharePoint',
    Controle_SharepointLink: 'Lien sharepoint*',

    CheckTemplateScope_Affaire: 'Chantier',
    CheckTemplateScope_General: 'Général',

    //* AFFAIRES
    Affaire_CodeAndName: '{code} - {name}',
    Affaire_CreateTitle: 'Créer un chantier',
    Affaire_Veille: 'CHANTIERS DU JOUR',
    Affaire_Today: 'TOUS LES CHANTIERS',

    //* USERS
    Users_FirstAndLastName: '{firstName} {lastName}',
    Users_LastAndFirstName: '{lastName} {firstName}',
    Users_FirstAndLastNameContractType: '{firstName} {lastName} - {contractType}',

    //* DIALOG
    Dialog_LogoutTitle: 'Déconnexion',
    Dialog_LogoutMessage: 'Êtes-vous sur de vouloir vous déconnecter ?',

    //* TOAST
    Toast_GenericSuccessUpdateData: 'Les données ont été mises à jour',
    Toast_TitleSuccess: 'Succès!',
    Toast_TitleError: 'Erreur!',
    Toast_TitleInfo: 'Info!',

    //* DateRangePicker
    DatePicker_DatePlaceholder: 'JJ / MM / AAAA',
    DatePicker_DatePlaceholder_Year: 'AAAA',
    DatePicker_DateFormat: 'dd / MM / yyyy',
    DatePicker_DateFormat_Year: 'yyyy',
    DatePicker_ClearLabel: 'Effacer',
    DatePicker_CancelLabel: 'Annuler',
    DateRangePicker_StartLabel: 'Du',
    DateRangePicker_EndLabel: 'Au',
    TimePicker_TimeFormat: 'HH : mm',

    //* InputText
    InputText_Adornment_Metres: 'Mètres',
    InputText_Adornment_Tonnes: 'Tonnes',
    InputText_Adornment_Name: 'Nom:',
    InputText_Adornment_Phone: 'Tél:',
    InputText_Adornment_Mail: 'Mail:',

    //* ListAffaires
    ListAffaires_SwitchTitle: 'Afficher uniquement les chantiers en cours',
    ListAffaires_CreateButtonTitle: 'Nouveau',
    ListAffaires_NumeroDevis: 'N° de devis',
    ListAffaires_Title: 'Chantier',
    ListAffaires_ClientName: 'Nom du client',
    ListAffaires_StartDate: 'Date de début',
    ListAffaires_EndDate: 'Date de fin',
    ListAffaires_ChargeAffaire: "Chargé d'affaires",
    ListAffaires_IsActive: 'Statut',

    //* AffaireDetails
    AffaireDetails_PreviousLabel: 'Chantiers',
    AffaireDetails_TabInformationTitle: 'Informations générales',
    AffaireDetails_TabControlTitle: 'Contrôles',
    AffaireDetails_TabPointageTitle: 'Pointage',
    AffaireDetails_NameCodeFormat: '{code} - {name}',

    //* AffaireControl
    AffaireControl_DatetimeFormat: 'Réalisée le : {day} / {month} / {year} - {hour}h{minute}',
    AffaireControl_Empty: 'Aucun contrôle disponible',

    //* AffaireInformation
    AffaireInfo_NumeroDevis: 'N° de devis*',
    AffaireInfo_Title: 'Nom du chantier*',
    AffaireInfo_IsActive: 'Chantier actif',
    AffaireInfo_IsInactive: 'Chantier inactif',
    AffaireInfo_StartDate: 'Débute le',
    AffaireInfo_EndDate: 'Fini le',
    AffaireInfo_HasNoEnd: 'Sans date de fin',
    AffaireInfo_Mission: 'Mission*',
    AffaireInfo_Recommandations: 'Recommandations particulières',
    AffaireInfo_Photo: 'Photo du chantier (Max. 20)',
    AffaireInfo_Pdf: 'Joindre un fichier PDF',
    AffaireInfo_ClientName: 'Nom du client',
    AffaireInfo_Zone: 'Zone',
    AffaireInfo_Adresse: 'Adresse',
    AffaireInfo_Contact: 'Contact',
    AffaireInfo_Type: 'Type',
    AffaireInfo_ChargeAffaire: "Chargé d'affaires",
    AffaireInfo_DailyControls: 'Contrôles quotidiens',
    AffaireInfo_AddDailyControls: 'Ajouter un contrôle quotidien',
    AffaireInfo_PunctualControls: 'Contrôles ponctuels',
    AffaireInfo_AddPunctualControls: 'Ajouter un contrôle ponctuel',
    AffaireInfo_allControlsListTitle: 'Contrôle Chantier',
    AffaireInfo_selectedControlsListTitle: 'Contrôle quotidien',
    AffaireInfo_Controle_Type: 'Type de contrôle',
    AffaireInfo_Controle_Type_Placeholder: 'Sélectionner un type de contrôle',
    AffaireInfo_Controle_Manager: 'Responsable',
    AffaireInfo_Controle_Manager_Placeholder: 'Sélectionner un responsable',

    AffaireType_Regie: 'Régie',
    AffaireType_Forfait: 'Forfait',

    AffaireInfo_errorRequiredFields:
        'Erreur. Pour enregistrer votre saisie, tous les champs obligatoires doivent être saisis.',

    //* AffaireElements
    AffaireDetails_TabElementsTitle: 'Éléments',
    ElementItem_Title: 'Élément {number}',
    ElementType_Personnel: 'Personnel',
    ElementType_Engin: 'Engin',
    ElementType_Materiel: 'Matériel',
    ElementType_Vehicule: 'Véhicule',
    AffaireElement_addElement: 'Ajouter un élément',
    ElementItem_Planifier: 'Planifier',

    ElementDialog_Title: 'AJOUTER UN ÉLEMENT À PLANIFIER',
    ElementDialog_Chantier: 'Chantier',
    ElementDialog_Name: 'Élement',
    ElementDialog_Affectation: "Souhait d'affectation",
    ElementDialog_Location: 'Location',
    ElementDialog_Cycle: 'Les jours',
    ElementDialog_HasNoEnd: 'Sans fin',
    ElementDialog_StartDate: 'Débute le',
    ElementDialog_EndDate: 'Fini le',
    ElementDialog_EnginDefault: 'Engin sans désignation',
    ElementDialog_VehiculeDefault: 'Véhicule sans désignation',
    ElementDialog_WarningNonOperationnel: 'Attention. Ce moyen est déclaré comme non opérationnel',
    ElementDialog_WarningDejaPlanifie:
        'Attention. Ce moyen est déjà planifié sur les dates sélectionnées',
    ElementDialog_AdvancedButton_Label: 'Élement au rythme irrégulier',

    //* AffairePointage
    AffairePointage_DateFormat: '{day} / {month} / {year}',

    //* Pointage
    Pointage_Monday: 'Lundi',
    Pointage_Tuesday: 'Mardi',
    Pointage_Wednesday: 'Mercredi',
    Pointage_Thursday: 'Jeudi',
    Pointage_Friday: 'Vendredi',
    Pointage_Saturday: 'Samedi',
    Pointage_Sunday: 'Dimanche',
    Pointage_Total: 'TOTAL',
    Pointage_comments: 'COMMENTAIRES:',
    Pointage_WeekDateFormat: '{year}-{month}-{day}',
    Pointage_TooltipCreatedFormat:
        'Pointé initialement par {trigram} le {dayText} {day}/{month}/{year} {hour}:{minute}',
    Pointage_TooltipModifiedFormat:
        'Modifié par {trigram} le {dayText} {day}/{month}/{year} {hour}:{minute}',
    Pointage_SortInfoCompagnon: 'Compagnon',
    Pointage_VueAffaire: 'Vue chantier',
    Pointage_VueCompagnon: 'Vue compagnon',
    Pointage_Empty: 'Aucun pointage disponible',
    Pointage_SelectPlaceholder: 'Tous',
    Pointage_SelectCompagnonPlaceHolder: 'CMP',
    Pointage_SelectAffairePlaceHolder: 'Chantier',
    Pointage_SelectChargeAffairePlaceHolder: 'CA',
    Pointage_SignaturePdfTitle: "Relevé d'heures {firstName} {lastName} {day}-{month}-{year}",
    Pointage_Dialog_Chantier: 'Chantier :',
    Pointage_Dialog_Compagnon: 'Compagnon :',
    Pointage_Dialog_Commentaire: 'Commentaire :',
    Pointage_AddButton: 'Ajouter un pointage',
    Pointage_Dialog_Work_Title: 'DÉTAIL HORAIRE',
    Pointage_Dialog_Deplacement_Title: 'DÉTAIL GRAND DÉPLACEMENT',
    Pointage_Dialog_Autre_Title: 'AUTRES INFORMATIONS',
    Pointage_Dialog_Work_StartWork: 'Heure arrivée :',
    Pointage_Dialog_Work_StartPause: 'Prise déjeuner (Début) :',
    Pointage_Dialog_Work_EndPause: 'Prise déjeuner (Fin) :',
    Pointage_Dialog_Work_EndWork: 'Heure départ :',
    Pointage_Dialog_Deplacement_TimeDriven: 'Temps route :',
    GrandDeplacementType_Aller: 'Aller',
    GrandDeplacementType_Retour: 'Retour',
    GrandDeplacementType_AllerRetour: 'Aller / Retour',
    VehiculeDeplacementType_VS: 'VS',
    VehiculeDeplacementType_VP: 'VP',
    VehiculeDeplacementType_Tracteur: 'Tracteur',
    VehiculeDeplacementType_Grue: 'Grue',
    Pointage_Dialog_Autre_Comment: 'Commentaire :',
    Pointage_AddDialog_Title: 'Ajouter un pointage',
    Pointage_AddDialog_Information_Text:
        "Le nouveau pointage ne sera enregistré qu'une fois la première saisie de temps faite.",
    Pointage_AddDialog_Compagnon: 'Compagnon :',
    Pointage_AddDialog_Chantier: 'Chantier :',
    Error_PointageAlreadyExists: 'Cette ligne de pointage existe déjà',
    PointageMission_Chantier_Title: 'Mission',
    PointageMission_ChargeAffaire_Title: 'N/A',

    //* RH
    RH_Title: 'RH',
    RH_PersonnelTab_Title: 'Personnel',
    RH_FormationsTab_Title: 'Formations',
    RH_AbsencesTab_Title: 'Absences',
    RH_VisitesMedicalesTab_Title: 'Visites Médicales',

    //* RH > Compagnons
    CompagnonDetails_PreviousLabel: 'Compagnons',
    CompagnonList_ExportButtonTitle: 'Exporter',
    CompagnonList_CreateButtonTitle: 'Nouveau',
    CompagnonList_CreatePageTitle: 'Créer un compagnon',
    CompagnonList_SwitchTitle: 'Afficher uniquement les compagnons actifs',
    CompagnonList_User: 'Utilisateur',
    CompagnonList_Phone: 'Téléphone',
    CompagnonList_Trigram: 'Trigramme',
    CompagnonList_Contract: 'Contrat',
    CompagnonList_Role: 'Rôle',
    CompagnonList_City: 'Ville',
    CompagnonList_State: 'État',
    Compagnon_ContractCDD: 'CDD',
    Compagnon_ContractCDI: 'CDI',
    Compagnon_ContractAlternant: 'Alternant',
    Compagnon_ContractInterim: 'Intérimaire',
    Compagnon_ContractAutoEntrepreneur: 'Auto entrepreneur',
    Compagnon_ContractSousTraitant: 'Sous-traitant',
    Compagnon_Stagiaire: 'Stagiaire',

    Compagnon_RoleCompagnon: 'Compagnon',
    Compagnon_RoleAdmin: 'Administrateur',
    Compagnon_RoleChargeAffaire: `Chargé d'affaires`,
    Compagnon_RoleChauffeur: 'Chauffeur',
    Compagnon_RoleChefEquipe: `Chef d'équipe`,
    CompagnonDetails_TabInformationTitle: 'Informations générales',
    CompagnonDetails_TabQualificationTitle: 'Documents',
    CompagnonDetails_TabControlTitle: 'Contrôles',
    CompagnonDetails_TabPointageTitle: 'Pointage',
    CompagnonDetails_TabHoursTitle: "Relevé d'heures",

    CompagnonDetails_InformationCompagnonLastName: "Nom de l'utilisateur*",
    CompagnonDetails_InformationCompagnonFirstName: "Prénom de l'utilisateur*",
    CompagnonDetails_InformationCompagnonPhone: 'Téléphone de l’utilisateur',
    CompagnonDetails_InformationCompagnonTrigram: 'Trigramme de l’utilisateur*',
    CompagnonDetails_InformationCompagnonRole: 'Rôle*',
    CompagnonDetails_InformationPoste: 'Poste',
    CompagnonDetails_InformationCompagnonSkills: 'Compétences',
    CompagnonDetails_InformationCompagnonChefEquipe: "Chef d'équipe",
    CompagnonDetails_InformationSendEmail: "Envoyer un email d'invitation",
    CompagnonDetails_InformationSendEmail_Success: 'Invitation envoyée !',
    CompagnonDetails_InformationCity: 'Ville',

    CompagnonDetails_Qualifications_Name: 'Nom du document',
    CompagnonDetails_Qualifications_Options: 'Options',
    CompagnonDetails_Qualifications_ValidityDate: 'Date de validité',
    CompagnonDetails_Qualifications_Pdf: 'Accès PDF',
    CompagnonDetails_Qualifications_Empty: 'Aucune qualification de disponible',
    CompagnonDetails_Qualifications_Name_CACES_CHARIOT_R489: 'CACES Chariot R489',
    CompagnonDetails_Qualifications_Name_CACES_NACELLE_R486: 'CACES Nacelle R486',
    CompagnonDetails_Qualifications_Name_CACES_GRUE_MOBILE_R483: 'CACES Grue mobile R483',
    CompagnonDetails_Qualifications_Name_CACES_ENGINS_CHANTIERS_R482: 'CACES Engins chantiers R482',
    CompagnonDetails_Qualifications_Name_CACES_PONT_R484: 'CACES Pont R484',
    CompagnonDetails_Qualifications_Name_HABILITATION_ELECTRIQUE: 'Habilitation Electrique',
    CompagnonDetails_Qualifications_Name_N1: 'N1',
    CompagnonDetails_Qualifications_Name_N2: 'N2',
    CompagnonDetails_Qualifications_Name_TRAVAIL_EN_HAUTEUR_PORT_DU_HARNAIS:
        'Travail en hauteur + Port du harnais',
    CompagnonDetails_Qualifications_Name_ELINGAGE: 'Elingage',
    CompagnonDetails_Qualifications_Name_SST: 'SST',
    CompagnonDetails_Qualifications_Name_CARTE_BTP: 'Carte BTP',
    CompagnonDetails_Qualifications_Name_AUTRES_CERTIFICATIONS: 'Autres certifications',
    CompagnonDetails_Qualifications_Name_AUTORISATION_DE_CONDUITE: 'Autorisation de conduite',
    CompagnonDetails_Qualifications_Name_VISITE_MEDICALE: 'Visite médicale',
    CompagnonDetails_Qualifications_Name_CARTE_IDENTITE_FR: "Carte d'identité FR",
    CompagnonDetails_Qualifications_Name_PASSEPORT_EU: 'Passeport EU',
    CompagnonDetails_Qualifications_Name_PERMIS_DE_CONDUIRE: 'Permis de conduire',
    CompagnonDetails_Qualifications_Name_CARTE_FIMO_FCO: 'Carte FIMO/FCO',
    CompagnonDetails_Qualifications_Name_CARTE_CONDUCTEUR_PL: 'Carte conducteur PL',
    //* RH > Formations
    FormationList_CreateButtonTitle: 'Nouveau',
    FormationList_Name: 'Formation',
    FormationList_UserName: 'Salarié',
    FormationList_StartDate: 'Date de début',
    FormationList_EndDate: 'Date de fin',
    FormationList_CenterName: 'Organisme de formation',
    FormationList_Empty: 'Aucune formation disponible',
    FormationDetails_Title: 'UN ELEMENT A PLANIFIER',
    FormationDetails_Name: 'Nom de la formation*',
    FormationDetails_CenterName: 'Nom du centre de formation*',
    FormationDetails_StartDate: 'Débute le*',
    FormationDetails_EndDate: 'Fini le*',
    FormationDetails_Compagnon: 'Salarié*',
    FormationDetails_Cycle: 'Les jours',
    FormationDetails_Convocation: 'Convocation',
    FormationDetails_AdvancedButton_Label: 'Formation au rythme irrégulier',
    Cycle_Lundi: 'Lundi',
    Cycle_Mardi: 'Mardi',
    Cycle_Mercredi: 'Mercredi',
    Cycle_Jeudi: 'Jeudi',
    Cycle_Vendredi: 'Vendredi',
    Cycle_Samedi: 'Samedi',
    Cycle_Dimanche: 'Dimanche',

    FormationToast_DeleteSuccess: 'Formation supprimée avec succès',

    //* RH > Absences

    AbsenceList_CreateButtonTitle: 'Nouveau',
    AbsenceList_Compagnon: 'Salarié',
    AbsenceList_StartDate: 'Date de début',
    AbsenceList_EndDate: 'Date de fin',
    AbsenceList_Type: "Motif de l'absence",
    AbsenceList_IsJustifie: 'Justificatif',
    AbsenceList_Empty: 'Aucune absence disponible',

    AbsenceDetails_Title: 'UN ELEMENT A PLANIFIER',
    AbsenceDetails_Compagnon: 'Salarié*',
    AbsenceDetails_StartDate: 'Débute le*',
    AbsenceDetails_EndDate: 'Fini le*',
    AbsenceDetails_Type: "Motif de l'absence*",
    AbsenceDetails_IsJustifie: 'Justificatif*',

    AbsenceToast_DeleteSuccess: 'Absence supprimée avec succès',

    Absence_TypeAtMp: 'AT/MP',
    Absence_TypeAutre: 'Autre',
    Absence_TypeCongesPayes: 'Congés payés',
    Absence_TypeCongesSansSolde: 'Congés sans solde',
    Absence_TypeEvenementFamilial: 'Evénement familial',
    Absence_TypeMaladie: 'Maladie',
    Absence_TypeAbsenceInjustifiee: 'Absence injustifiée',

    //* RH > Visites Medicales
    VisiteMedicaleList_CreateButtonTitle: 'Nouveau',
    VisiteMedicaleList_Compagnon: 'Salarié',
    VisiteMedicaleList_Date: 'Date du RDV',
    VisiteMedicaleList_Type: 'Type',
    VisiteMedicaleList_Result: 'Résultat',
    VisiteMedicaleList_Empty: 'Aucune visite médicale disponible',

    VisiteMedicaleDetails_Title: 'UN ELEMENT A PLANIFIER',
    VisiteMedicaleDetails_Compagnon: 'Salarié*',
    VisiteMedicaleDetails_Type: 'Type de visite*',
    VisiteMedicaleDetails_Date: 'Date de la visite*',
    VisiteMedicaleDetails_Result: 'Résultat de la visite',
    VisiteMedicaleDetails_Convocation: 'Convocation',

    VisiteMedicaleToast_DeleteSuccess: 'Visite médicale supprimée avec succès',

    VisiteMedicale_TypeInitiale: 'Initiale',
    VisiteMedicale_TypeDeReprise: 'Reprise',
    VisiteMedicale_TypePeriodique: 'Périodique',
    VisiteMedicale_ResultApte: 'Apte',
    VisiteMedicale_ResultInapte: 'Inapte',
    VisiteMedicale_ResultInaptitudeTemporaire: 'Inaptitude temporaire',

    //* Engins
    EnginList_Label: 'Engins',
    EnginDetails_PreviousLabel: 'Engins',
    EnginList_ExportButtonTitle: 'Exporter',
    EnginList_CreateButtonTitle: 'Nouveau',
    EnginList_CreatePageTitle: 'Créer un nouvel engin',
    EnginList_Code: 'Code',
    EnginList_IsOperationnel: 'Opérationnel',
    EnginList_Type: 'Type',
    EnginList_Energie: 'Energie',
    EnginList_Capacite: 'Capacité (T)',
    EnginList_HauteurDeLevee: 'H. de levée (M)',
    EnginList_DateDeValiditeVGP: 'Validité VGP',
    EnginList_Empty: 'Aucun engin disponible',
    EnginList_Hauteur: 'Hauteur',
    EnginList_Largeur: 'Largeur',
    EnginList_Marque: 'Marque',
    EnginList_LongueurSansFourche: 'Longueur sans fourche',
    EnginList_LongueurAvecFourche: 'Longueur avec fourche',
    EnginList_SwitchTitle: 'Afficher uniquement les engins actifs',

    EnginType_Grue: 'Grue',
    EnginType_GrueMobile: 'Grue Mobile',
    EnginType_GrueTelescopique: 'Grue Télescopique',
    EnginType_Chariot: 'Chariot',
    EnginType_NacelleCiseaux: 'Nacelle Ciseaux',
    EnginType_NacelleToucan: 'Nacelle Toucan',
    EnginType_NacelleBrasTelescopique: 'Nacelle Bras Télescopique',
    EnginType_Gerbeur: 'Gerbeur',
    EnginType_Autre: 'Autre',

    EnergieType_Diesel: 'Diesel',
    EnergieType_Electrique: 'Electrique',
    EnergieType_Essence: 'Essence',
    EnergieType_Gaz: 'Gaz',

    EnginDetails_TabInformationTitle: 'Informations générales',
    EnginDetails_TabControlTitle: 'Contrôles',

    EnginDetails_Information_Code: 'Code*',
    EnginDetails_Information_CarteGrise: 'Pdf carte grise / plaque signalétique',
    EnginDetails_Information_Marque: 'Marque',
    EnginDetails_Information_Capacite: 'Capacité (T)',
    EnginDetails_Information_Energie: 'Energie',
    EnginDetails_Information_DateDeValiditeAssurance: 'Date de validité assurance',
    EnginDetails_Information_AttestationAssurance: 'Pdf Attestation assurance',
    EnginDetails_Information_DateDeValiditeVGP: 'Date de validité VGP',
    EnginDetails_Information_VGP: 'Pdf VGP',
    EnginDetails_Information_OptionsSupplementaires: 'Options supplémentaires',
    EnginDetails_Information_FicheTechnique: 'Fiche technique',
    EnginDetails_Information_Photo: "Photo de l'engin",
    EnginDetails_Information_IsOperationnel: 'Opérationnel',
    EnginDetails_Information_Type: 'Type',
    EnginDetails_Information_Modele: 'Modèle',
    EnginDetails_Information_HeuteurDeLevee: 'Hauteur de levée (M)',
    EnginDetails_Information_NumeroDeSerie: 'N° de série',
    EnginDetails_Information_Options: 'Options',
    EnginDetails_Information_CaracteristiquesTechniques: 'Caractéristiques techniques',
    EnginDetails_Information_LongueurSansFourches: 'Longueur sans fourches (M)',
    EnginDetails_Information_LongueurAvecFourches: 'Longueur avec fourches (M)',
    EnginDetails_Information_Largeur: 'Largeur (M)',
    EnginDetails_Information_Hauteur: 'Hauteur (M)',
    EnginDetails_Information_PoidsAVide: 'Poids à vide (T)',
    EnginDetails_Information_FicheUtilisation: "Fiche d'utilisation",
    EnginDetails_Information_Comment: 'Commentaire',
    EnginDetails_Information_Designation: 'Désignation',
    EnginDetails_Information_IsActif: 'Actif',
    EnginDetails_Information_IsInactif: 'Inactif',
    EnginDetails_Information_AnneeFabrication: 'Année de fabrication',

    EnginOption_JibHydrauliqueJibHydraulique: 'Jib hydraulique',
    EnginOption_JibManuel: 'Jib manuel',
    EnginOption_RouesBlanches: 'Roues blanches',
    EnginOption_RouesNoires: 'Roues noires',
    EnginOption_Treuil: 'Treuil',
    EnginOption_Stabilisateur: 'Stabilisateur',
    EnginOption_ColDeCygne: 'Col de cygne',
    EnginOption_LonguesFourches: 'Longues Fourches',
    EnginOption_RallongesFourches: 'Rallonges fourches',
    EnginOption_TablierDeplacementLateral: 'Tablier déplacement latéral',

    //* Materiels
    MaterielList_Label: 'Materiels',
    MaterielDetails_PreviousLabel: 'Materiels',
    MaterielList_ExportButtonTitle: 'Exporter',
    MaterielList_CreateButtonTitle: 'Nouveau',
    MaterielList_CreatePageTitle: 'Créer un nouveau materiel',
    MaterielList_Code: 'Code',
    MaterielList_IsOperationnel: 'Opérationnel',
    MaterielList_Type: 'Type',
    MaterielList_Energie: 'Energie',
    MaterielList_Capacite: 'Capacité',
    MaterielList_HauteurDeLevee: 'H. de levée (M)',
    MaterielList_DateDeValiditeVGP: 'Validité VGP',
    MaterielList_Nom: 'Nom',
    MaterielList_Marque: 'Marque',
    MaterielList_Diametre: 'Diamètre',
    MaterielList_Empty: 'Aucun materiel disponible',
    MaterielType_Manutuention: 'Manutention',
    MaterielType_GrosOutillage: 'Gros outillage',
    MaterielType_PetitOutillage: 'Petit outillage',
    MaterielList_SwitchTitle: 'Afficher uniquement les matériels actifs',
    MaterielType_Conditionnement: 'Conditionnement',

    MaterielEnergieType_Batterie: 'Batterie',
    MaterielEnergieType_Diesel: 'Diesel',
    MaterielEnergieType_Essence: 'Essence',
    MaterielEnergieType_ElectriqueFilaire: 'Electrique filaire',
    MaterielEnergieType_Gaz: 'Gaz',
    MaterielEnergieType_Pneumatique: 'Pneumatique',

    MaterielDetails_TabInformationTitle: 'Informations générales',
    MaterielDetails_TabControlTitle: 'Contrôles',

    MaterielDetails_Information_Code: 'Code*',
    MaterielDetails_Information_Nom: 'Nom*',
    MaterielDetails_Information_NumeroDeSerie: 'N° de série',
    MaterielDetails_Information_Type: 'Type',
    MaterielDetails_Information_Energie: 'Energie',
    MaterielDetails_Information_DateDeValiditeVGP: 'Validité VGP',
    MaterielDetails_Information_VGP: 'Pdf VGP',
    MaterielDetails_Information_OptionsSupplementaires: 'Options supplémentaires',
    MaterielDetails_Information_Photo: 'Photo du materiel',
    MaterielDetails_Information_IsOperationnel: 'Opérationnel',
    MaterielDetails_Information_Marque: 'Marque',
    MaterielDetails_Information_Modele: 'Modèle',
    MaterielDetails_Information_HauteurDeLevee: 'Hauteur de levée (M)',
    MaterielDetails_Information_Capacite: 'Capacité',
    MaterielDetails_Information_Diametre: 'Diamètre',
    MaterielDetails_Information_FicheUtilisation: "Fiche d'utilisation",
    MaterielDetails_Information_FicheTechnique: 'Fiche technique',
    MaterielDetails_Information_Comment: 'Commentaire',

    MaterielDetails_Information_Actif: 'Actif',
    MaterielDetails_Information_Inactif: 'Inactif',

    //* Vehicules
    VehiculeList_Label: 'Véhicules',
    VehiculeDetails_PreviousLabel: 'Véhicules',
    VehiculeList_ExportButtonTitle: 'Exporter',
    VehiculeList_CreateButtonTitle: 'Nouveau',
    VehiculeList_CreatePageTitle: 'Créer un nouveau véhicule',
    VehiculeList_SwitchTitle: 'Afficher uniquement les véhicules actifs',

    VehiculeList_Empty: 'Aucun véhicule disponible',
    VehiculeType_Manutuention: 'Manutention',
    VehiculeType_GrosOutillage: 'Gros outillage',
    VehiculeType_PetitOutillage: 'Petit outillage',
    VehiculeType_Conditionnement: 'Conditionnement',
    VehiculeList_Code: 'Code',
    VehiculeList_Designation: 'Désignation',
    VehiculeList_NumeroImmatriculation: 'Immat',
    VehiculeList_IsOperationnel: 'Opérationnel',
    VehiculeList_Compagnon: 'Attribué',
    VehiculeList_Type: 'Type',
    VehiculeList_NombreDePlace: 'Nbr Places',
    VehiculeList_DateValiditeControleTechnique: 'Validité CT',
    VehiculeList_DateValiditeAntiPollution: 'Validité Anti_P',
    VehiculeList_DateValiditeTachy: 'Validité Tachy',

    VehiculeDetails_TabInformationTitle: 'Informations générales',
    VehiculeDetails_TabControlTitle: 'Contrôles',

    VehiculeDetails_Information_Code: 'Code*',
    VehiculeDetails_Information_Designation: 'Désignation',
    VehiculeDetails_Information_CarteGrise: 'PDF Carte Grise',
    VehiculeDetails_Information_DateImmatriculation: 'Date 1ere immatriculation',
    VehiculeDetails_Information_IsAttribue: 'Attribué',
    VehiculeDetails_Information_Compagnon: 'Nom du salarié*',
    VehiculeDetails_Information_Marque: 'Marque',
    VehiculeDetails_Information_Energie: 'Energie',
    VehiculeDetails_Information_PermisType: 'Permis requis',
    VehiculeDetails_Information_DateValiditeAssurance: 'Date validité assurance',
    VehiculeDetails_Information_PdfAttestationAssurance: 'PDF Attestation assurance',
    VehiculeDetails_Information_DateValiditeCT: 'Date validité contrôle technique',
    VehiculeDetails_Information_DateValiditeAnti_P: 'Date validité anti pollution',
    VehiculeDetails_Information_DateValiditeTachy: 'Date validité TACHY',
    VehiculeDetails_Information_PdfTachy: 'PDF TACHY',
    VehiculeDetails_Information_PdfTSVR: 'Attestation TSVR',
    VehiculeDetails_Information_Photo: 'Photo du véhicule',
    VehiculeDetails_Information_Comment: 'Commentaire',

    VehiculeDetails_Information_IsOperationnel: 'Opérationnel',
    VehiculeDetails_Information_NumeroImmatriculation: 'Numéro immatriculation*',
    VehiculeDetails_Information_VehiculeType: 'Type',
    VehiculeDetails_Information_NombreDePlaceType: 'Nombre de places',
    VehiculeDetails_Information_Modele: 'Modèle',
    VehiculeDetails_Information_PdfLicenseTransportInterieur: 'License transport interieur',
    VehiculeDetails_Information_PdfLicenseTransportInternational: 'License transport international',
    VehiculeDetails_Information_IsCritAir: "Crit'Air",
    VehiculeDetails_Information_PneusType: 'Pneus montés',
    VehiculeDetails_Information_Options: 'Options',
    VehiculeDetails_Information_VehiculeOptionType_TableElevatrice: 'Table élevatrice',
    VehiculeDetails_Information_VehiculeOptionType_Extensible: 'Extensible',
    VehiculeDetails_Information_VehiculeOptionType_AttacheRemorque: 'Attache remorque',
    VehiculeDetails_Information_VehiculeOptionType_Galerie: 'Galerie',
    VehiculeDetails_Information_VehiculeOptionType_Autre: 'Autre',
    VehiculeDetails_Information_OptionAutre: 'Option (autre)',
    VehiculeDetails_Information_PdfCaracteristiquesTechniques: 'Caractéristiques techniques',
    VehiculeDetails_Information_CaracteristiquesTechniques: 'Caractéristiques techniques',
    VehiculeDetails_Information_Longueur: 'Longueur (M)',
    VehiculeDetails_Information_Largeur: 'Largeur (M)',
    VehiculeDetails_Information_Hauteur: 'Hauteur (M)',
    VehiculeDetails_Information_PoidsAVide: 'Poids à vide (T)',
    VehiculeDetails_Information_PoidsRoulant: 'Poids total roulant (T)',
    VehiculeDetails_Information_IsActif: 'Actif',
    VehiculeDetails_Information_IsInactif: 'Inactif',

    Error_VehiculeDetails_Information_Compagnon_HasVehiculeAffecte:
        'Attention ce salarié a déjà un véhicule attribué',

    PneusType_Ete: 'Eté',
    PneusType_Hiver: 'Hiver',
    PneusType_QuatreSaisons: 'Quatre saisons',

    NombreDePlace_Deux: '2',
    NombreDePlace_Trois: '3',
    NombreDePlace_Quatre: '4',
    NombreDePlace_Cinq: '5',
    NombreDePlace_Sept: '7',
    NombreDePlace_Neuf: '9',
    NombreDePlace_Autre: 'Autre',

    VehiculeType_Tracteur: 'Tracteur',
    VehiculeType_Remorque: 'Remorque',
    VehiculeType_Grue: 'Grue',
    VehiculeType_Utilitaire: 'Utilitaire',
    VehiculeType_Commerciale: 'Commerciale',
    VehiculeType_Autre: 'Autre',

    PermisType_B: 'B',
    PermisType_B1: 'B1',
    PermisType_BE: 'BE',
    PermisType_C: 'C',
    PermisType_C1: 'C1',
    PermisType_C1E: 'C1E',
    PermisType_CE: 'CE',

    //* Clients
    ClientList_Label: 'Clients',
    ClientDetails_PreviousLabel: 'Clients',
    ClientList_ExportButtonTitle: 'Exporter',
    ClientList_CreateButtonTitle: 'Nouveau',
    ClientList_CreatePageTitle: 'Créer un nouveau client',
    ClientList_Libelle: 'Nom client',
    ClientList_Adresse: 'Adresse',
    ClientList_ZipCode: 'Code postal',
    ClientList_City: 'Ville',
    ClientList_Country: 'Pays',
    ClientList_Zone: 'Zone',
    ClientList_Empty: 'Aucun client disponible',

    ClientDetails_TabInformationTitle: 'Informations générales',

    ClientDetails_Information_ClientSection: 'Infos client :',
    ClientDetails_Information_Libelle: 'Libellé*',
    ClientDetails_Information_Adresse: 'Adresse',
    ClientDetails_Information_ZipCode: 'Code postal',
    ClientDetails_Information_City: 'Ville',
    ClientDetails_Information_Country: 'Pays',
    ClientDetails_Information_Zone: 'Zone',
    ClientDetails_Information_IsActive: 'Actif',
    ClientDetails_Information_IsInactive: 'Inactif',
    ClientDetails_Information_Statut: 'Statut*',
    ClientDetails_Information_ContactSection: 'Contact :',
    ClientDetails_Information_ContactName: 'Nom',
    ClientDetails_Information_ContactMail: 'Mail',
    ClientDetails_Information_ContactPhone: 'Téléphone',

    ZoneType_Km1: '1',
    ZoneType_Km2: '2',
    ZoneType_Km3: '3',
    ZoneType_Km4: '4',
    ZoneType_Km5: '5',
    ZoneType_Km6: '6',
    ZoneType_Km7: '7',
    ZoneType_Km8: '8',
    ZoneType_Km9: '9',
    ZoneType_Km10: '10',
    ZoneType_Km11: '11',
    ZoneType_Km12: '12',
    ZoneType_Km13: '13',
    ZoneType_Km14: '14',
    ZoneType_Km15: '15',
    ZoneType_Km16: '16',
    ZoneType_Km17: '17',
    ZoneType_Km18: '18',
    ZoneType_Km19: '19',
    ZoneType_Km20: '20',
    ZoneType_GrandDeplacement: 'Grand déplacement',

    ClientList_ShowOnlyActive: 'Afficher uniquement les clients actifs',

    //* Compagnon Information Skills
    Compagnon_SkillsMecanique: 'Mécanique',
    Compagnon_SkillsElectricite: 'Electricité',
    Compagnon_SkillsSoudure: 'Soudure',
    Compagnon_SkillsConduiteChariot: 'Conduite chariot',
    Compagnon_SkillsConduiteGrue: 'Conduite grue',
    Compagnon_SkillsConduiteNacelles: 'Conduite nacelles',
    Compagnon_SkillsConduitePontRoulant: 'Conduite pont roulant',
    Compagnon_SkillsConduiteEnginsDeChantier: 'Conduite engins de chantier',
    Compagnon_SkillsConduitePL: 'Conduite PL',
    Compagnon_SkillsConduiteVL: 'Conduite VL',

    CompagnonDetails_InformationCompagnonSecurity: 'Référent sécurité',
    CompagnonDetails_InformationCompagnonTechnical: 'Référent technique',
    CompagnonDetails_InformationCompagnonAutonomy: 'Autonomie',
    CompagnonDetails_InformationCompagnonLastMedicalVisit: 'Dernière visite médicale',
    CompagnonDetails_InformationCompagnonContract: 'Contrat*',
    CompagnonDetails_InformationCompagnonActive: 'Utilisateur actif',
    CompagnonDetails_InformationCompagnonInactive: 'Utilisateur inactif',
    CompagnonDetails_InformationCompagnonHasAccess: "Accès à l'app ?",
    CompagnonDetails_InformationCompagnonHasAccessBO: 'Accès au back office ?',
    CompagnonDetails_InformationCompagnonEmail: 'Email de l’utilisateur',
    CompagnonDetails_InformationCompagnonEmailRequired: 'Email de l’utilisateur*',
    Compagnon_diplomas: 'Diplômes:',
    Compagnon_formations: 'Formations:',
    CompagnonDetails_InformationCompagnonVehiculeAffecte: 'Véhicule(s) affecté(s)',
    CompagnonDetails_InformationAgencyEmail: 'Email de l’agence intérim',
    CompagnonDetails_InformationAgencyName: 'Nom de l’agence intérim*',
    CompagnonControl_Empty: 'Aucun contrôle disponible',

    CompagnonHeures_Start: 'Début:',
    CompagnonHeures_End: 'Fin:',
    CompagnonHeures_SignDate: 'Date de la signature:',
    CompagnonHeures_Empty: "Aucun relevé d'heures disponible",

    //* Select
    Select_Placeholder: '-',

    //* Causerie
    CauserieList_CreateButtonTitle: 'Nouveau',
    CauserieList_Causerie: 'Causerie',
    CauserieList_CreatedBy: 'Créée par',
    CauserieList_CompagnonNb: 'Nb de compagnons',
    CauserieList_Publication: 'Publication',
    CauserieInformations_Name: 'Nom de causerie*',
    CauserieInformations_Description: 'Description',
    CauserieInformations_Pdf: 'Joindre un fichier PDF',
    CauserieInformations_DeleteButtonTitle: 'Supprimer la causerie',
    CauserieInformations_PublishButtonTitle: 'Publier la causerie',

    CauserieCreate_Title: 'Créer une causerie',
    CauserieCreate_FieldMissing:
        'Pour enregistrer une causerie, vous devez lui attribuer un libellé',
    CauserieSavePublished_FieldMissing:
        'Pour publier la causerie, vous devez saisir au moins 1 titre, 1 description et joindre 1 pdf',
    CauserieDetails_PreviousLabel: 'Causeries',
    CauserieDetails_TabInformationsTitle: 'Informations générales',
    CauserieDetails_TabResultTitle: 'Résultats',
    CauserieDetails_Publication: 'Publiée le {day}/{month}/{year} par {trigram}',
    CauserieDetails_SuccessPublish: 'Causerie publiée avec succès',
    CauserieDetails_SuccessDelete: 'Causerie supprimée avec succès',
    CauserieDetails_DeleteDialogTitle: 'Suppimer la causerie',
    CauserieDetails_DeleteDialogContent: 'Voulez vous vraiment supprimer la causerie ?',
    CauserieDetails_DeleteDialogLeftAction: 'Supprimer',
    CauserieDetails_DeleteDialogRightAction: 'Annuler',

    CauserieDetails_ResultCompagnon: 'Compagnon',
    CauserieDetails_ResultDate: 'Date de la causerie',
    CauserieDetails_ResultWho: 'Qui',

    //* MESSAGE
    Message_WrapperLabel: 'Contenu du message',
    Message_PublishUnpublish: 'Publier / dépublier le message: ',
    Message_Published: 'Message publié',
    Message_NotPublished: 'Message non publié',
    Message_PlaceHolder: 'Saisir le message...',

    //* DIALOG
    Dialog_ConfirmTitle: 'Quitter',
    Dialog_ConfirmMessage:
        'Les modifications vont être perdues, voulez-vous vraiment quitter la page ?',
    Dialog_ConfirmCancel: 'Annuler',
    Dialog_ConfirmQuit: 'Quitter',

    //*Control PDF title
    Control_PdfTitleFormatGeneral: '{controlTitle} {year}{month}{day}-{hour}h{minutes}',
    Control_PdfTitleFormatGeneralWithoutDate: '{controlTitle}',
    Control_PdfTitleFormat:
        '{controlTitle} {affaireNumber} {affaireTitle} {year}{month}{day}-{hour}h{minutes}',
    Control_PdfTitleFormatWithoutDate: '{controlTitle}',

    Control_PdfDownloadProgress: 'Téléchargement en cours : {value}%',
    Control_DayDateFormat: '{year}-{month}-{day}',

    //* Common Upload file
    UploadFile_DownloadTitle: 'Télécharger le fichier',
    UploadFile_NoFileError: 'Aucun fichier à télécharger',
    UploadFile_Info: 'Joindre un fichier PDF*',

    //* Planning
    PlanningPage_Title: 'PLANNING',
    PlanningPage_Export_Title: 'EXPORTER',
    PlanningPage_Export_Tooltip: 'Exporter',
    PlanningPage_Save_Title: 'ENREGISTRER',
    PlanningPage_Save_Tooltip: 'Enregistrer',
    PlanningPage_Publish_Title: 'PUBLIER',
    PlanningPage_Publish_Tooltip: 'Publier',
    PlanningPage_Publish_Text: 'Dernière publication: {jour}/{mois}/{annee}',
    PlanningPage_Publish_Text_Empty: 'Dernière publication: -',
    PlanningPage_Publish_Dialog_Message:
        "Êtes vous sûr(e) de vouloir publier le planning du {start_day}/{start_month}/{start_year} au {end_day}/{end_month}/{end_year} ? L'ensemble des informations de cette semaine sera visible sur l'application Loxo",
    PlanningPage_Publish_Dialog_Title: 'Publication du planning',
    PlanningPage_Publish_Dialog_Confirm: 'Publier',
    PlanningPage_WeekNumber: 'SEMAINE {weekNumber}',
    PlanningCard_Add_Title: 'Ajouter un élément',
    PlanningCard_VisitesMedicales_Title: 'VISITES MÉDICALES',
    PlanningCard_Absences_Title: 'ABSENCES',
    PlanningCard_Formations_Title: 'FORMATIONS',
    PlanningCard_VisiteMedicale_Title: 'Salariés',
    PlanningComment_Absence_TitleHeader: 'Absence',
    PlanningComment_Formation_TitleHeader: 'Formation',
    PlanningComment_VisiteMedicale_TitleHeader: 'Visite médicale',
    PlanningComment_Date_TitleInfo: '{jour}/{mois}/{annee}',
    PlanningComment_Mission_TitleHeader: 'Mission',
    PlanningDialog_ConfirmSave: 'Enregistrer',
    PlanningDialog_ConfirmMessage:
        'Vous allez quitter le planning, voulez-vous enregistrer vos dernières modifications ? Si vous quittez sans enregistrer, elles seront perdues.',
    PlanningDialog_ConfirmTitle: 'Enregistrer',
    PlanningDialog_ConfirmCancel: 'Quitter',
    PlanningCard_Missions_Title: 'MISSIONS',
    PlanningCard_Missions_TitleHeader: 'Chauffeurs',
    Planning_Error_AffectationAlreadyExists:
        'Vous ne pouvez pas planifier 2 fois le même moyen sur une semaine.',
    Planning_WeekPicker_Week: 'Semaine',
    Planning_WeekPicker_To: 'au',
    Planning_Error_NoLastWeekData: 'Aucune donnée disponible pour la semaine précédente',

    //* Planning Volet
    PlanningVueType_Chantier: 'CHANTIER',
    PlanningVueType_Engin: 'ENGIN',
    PlanningVueType_Personnel: 'PERSONNEL',
    PlanningVueType_Vehicule: 'VÉHICULE',
    PlanningVueType_Materiel: 'MATÉRIELS',

    PlanningVolet_Personnel: 'PERSONNEL',
    PlanningVolet_Engin: 'ENGIN',
    PlanningVolet_Materiel: 'MATÉRIEL',
    PlanningVolet_Vehicule: 'VÉHICULE',

    PlanningVolet_Filters_Title_Format: 'FILTRES ({count})',
    PlanningVolet_Filters_Title_Empty: 'FILTRES',

    PlanningRow_Location: 'Location',

    Planning_Header_Chantier: '{name} ({el_name})',
    Planning_Header_Mission: 'Mission',

    PlanningPersonnel_Header_Formation: 'Formation ({name})',
    PlanningPersonnel_Header_Absence: 'Absence ({type})',
    PlanningPersonnel_Header_VisiteMedicale: 'Visite médicale',

    PlanningEngin_PlanningRow_Title: '{name} {title}',
    PlanningVehicule_PlanningRow_Title: '{name} {title}',

    VehiculeVolet_NombreDePlace: 'Nombre de places',
    VehiculeVolet_VehiculeType: 'Type de véhicule',
    VehiculeVolet_PneusType: 'Type de pneus',

    MaterielVolet_MaterielEnergieType: "Type d'énergie",
    MaterielVolet_MaterielType: 'Type de matériel',

    PersonnelVolet_CompagnonSkills: 'Compétences',
    PersonnelVolet_Position: 'Poste',

    EnginVolet_EnergieType: "Type d'énergie",
    EnginVolet_EnginType: "Type d'engin",

    VehiculeVoletCard_EmptyTitle: 'Véhicule sans désignation',
    EnginVoletCard_EmptyTitle: 'Engin sans désignation',

    PlanningExportDialog_StartDate: 'Date de début*',
    PlanningExportDialog_EndDate: 'Date de fin*',
    PlanningPage_Export_Dialog_Confirm: 'Exporter',
    PlanningPage_Export_Dialog_Title: 'Exporter le planning',
    PlanningPage_Export_Dialog_Date_Error: 'Champs obligatoire',
};
